<template>
  <div
    :class="cn('tw:flex tw:px-6 tw:pb-4 tw:border-b tw:flex-col tw:gap-y-1.5 tw:text-left', props.class)"
  >
    <slot />
  </div>
</template>

<script setup>
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
})
</script>
